import React from "react";
import Button from "@components/Ui/Button/index.js";

import "./style.scss";

const ActionBar = ({ itemCount = 0, onCheckout, isVisible = false }) => {

    return (
        <div
            className={`actionbar__wrapper${isVisible ? " actionbar__wrapper--visible" : ""}`}
            role="region"
            aria-label="Cart summary"
            aria-hidden={!isVisible}
        >
            <div className="actionbar__summary">
                {itemCount} {itemCount === 1 ? "Voucher added to cart" : "Vouchers added to cart"}
            </div>
            <Button additionalClasses="actionbar__button" onClick={onCheckout}>
                View Cart
            </Button>

        </div>
    );
};

export default ActionBar;
